const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.PRODUCTION_PRODUCT_TYPES)

export const apiProductionProductTypes = {
	fetchProductionProductTypes: async (
		currentPage: number,
	): Promise<IApiResponseModel<IProductionProductTypeModel[]>> => {
		const { data, meta } = await apiCommon<IProductionProductType[]>(groupPrefix, {
			method: 'GET',
			...createQuery({ page: currentPage, perPage: 25 }),
		})

		return { data: data.map(d => ProductionProductType(d)), meta }
	},
	createProductionProductType: async (
		payload: IProductionProductTypeCreatePayload,
	): Promise<IProductionProductTypeModel> => {
		const { data } = await apiCommon<IProductionProductType>(`${groupPrefix}`, { method: 'POST', body: payload })

		return ProductionProductType(data)
	},
	updateProductionProductType: async (
		payload: IProductionProductTypeUpdatePayload,
	): Promise<IProductionProductTypeModel> => {
		const { data } = await apiCommon<IProductionProductType>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return ProductionProductType(data)
	},
}
